import { render, staticRenderFns } from "./500.vue?vue&type=template&id=f5c5152c"
import script from "./500.vue?vue&type=script&lang=js"
export * from "./500.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PrimaryButton: require('/vercel/path0/components/ui/primaryButton.vue').default})
